/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

// Action Creator
export const types = {
  FETCH_DATAPIPE: "[Datapipe] Fetch Datapipe",
  FETCH_DATAPIPE_SUCCESS: "[Datapipe] Fetch Datapipe success",
  FETCH_DATAPIPE_FAILED: "[Datapipe] Fetch Datapipe failed",

  FETCH_A_DATAPIPE: "[Datapipe] Fetch a Datapipe",
  FETCH_A_DATAPIPE_SUCCESS: "[Datapipe] Fetch a Datapipe success",
  FETCH_A_DATAPIPE_FAILED: "[Datapipe] Fetch a Datapipe failed",

  CHANGE_STATUS_DATAPIPE: "[Datapipe] Change status of current Datapipe",
  CHANGE_STATUS_DATAPIPE_SUCCESS:
    "[Datapipe] Change status of current Datapipe success",
  CHANGE_STATUS_DATAPIPE_FAILED:
    "[Datapipe] Change status of current Datapipe failed",

  CREATE_DATAPIPE: "[Datapipe] Create datapipe",
  CREATE_DATAPIPE_SUCCESS: "[Datapipe] Create datapipe success",
  CREATE_DATAPIPE_FAILED: "[Datapipe] Create datapipe failed",

  UPDATE_DATAPIPE: "[Datapipe] Update datapipe",
  UPDATE_DATAPIPE_SUCCESS: "[Datapipe] Update datapipe success",
  UPDATE_DATAPIPE_FAILED: "[Datapipe] Update datapipe failed",
  RERENDER_DATAPIPE: "[Datapipe] Rerender datapipe failed",

  ADD_COLLECTOR_TO_DATAPIPE: "[Datapipe] Add collector to datapipe",
  CHANGE_CURRENT_DATAPIPE_NAME: "[Datapipe] Change current datapipe name",
  ADD_PLAYERDATA_TO_DATAPIPE: "[Datapipe] Add player data to datapipe",
  ADD_CONNECTOR_TO_DATAPIPE: "[Datapipe] Add Connector to datapipe",
  REMOVE_COLLECTOR_FROM_DATAPIPE: "[Datapipe] Remove Collector from datapipe",
  REMOVE_CONNECTOR_FROM_DATAPIPE: "[Datapipe] Remove Connector from datapipe",
  RESET_CURRENT_DATAPIPE: "[Datapipe] Reset current datapipe",

  VERIFY_PLAYERS: "[Datapipe] Verify Datapipe Players",
  STORE_DATAPIPE_SEARCH: "[Datapipe] Store Datapipe search ",
  REMOVE_DATAPIPE_SEARCH: "[Datapipe] Remove Datapipe search ",
  SET_DATAPIPE_FILTER_ACTIVE_DISABLE: "[Datapipe] Set Datapipe Active Disable ",
  REMOVE_DATAPIPE_FILTER_ACTIVE_DISABLE:
    "[Datapipe] Remove Datapipe Active Disable ",
  FETCH_A_DATAPIPE_DEL: "[Datapipe] Fetch a Datapipe Delete Conatainer",
  FETCH_A_DATAPIPE_DEL_SUCCESS:
    "[Datapipe] Fetch a Datapipe Delete Conatainer success",
  FETCH_A_DATAPIPE_DEL_FAILED:
    "[Datapipe] Fetch a Datapipe Delete Conatainer failed",

  DELETE_DATAPIPE: "[Datapipe] Delete Datapipe",
  DELETE_DATAPIPE_SUCCESS: "[Datapipe] Delete Datapipe success",
  DELETE_DATAPIPE_FAILED: "[Datapipe] Delete Datapipe failed",
  REMOVE_DEL_DATAPIPE: "[Connectors] Remove Delete Conatainer datapipe",
  CLEAR_DATAPIPE_LIST: "[Connectors] Clear Datapipe list",
  CLEAR_ERROR_RESPONSE: "[Datapipe] Clear Datapipe error response",
  CLEAR_ERROR_DATA_PIPE_RESPONSE: "[Datapipe] Clear Error Datapipe response",
  CLEAR_SUCCESS_DATA_PIPE_RESPONSE:
    "[Datapipe] Clear Success Datapipe response",
  LOAD_MORE_DATAPIPE: "[Datapipe] Load More Datapipe",
  LOAD_MORE_DATAPIPE_SUCCESS: "[Datapipe] Load More Datapipe success",
  LOAD_MORE_DATAPIPE_FAILED: "[Datapipe] Load More Datapipe failed",
  HIDE_DATAPIPE: "[Datapipe] Hide Datapipe",
  HIDE_DATAPIPE_SUCCESS: "[Datapipe] Hide Datapipe success",
  HIDE_DATAPIPE_FAILED: "[Datapipe] Hide Datapipe failed",
  UNHIDE_DATAPIPE_SUCCESS: "[Datapipe] Unide Datapipe success",
  UNHIDE_DATAPIPE_FAILED: "[Datapipe] Unhide Datapipe failed",
  INITIAL_DATAPIPE_VALUE: "[Datapipe] Initial Datapipe value",
  FETCH_A_DATAPIPE_LOGS: "[CustomData] Fetch a Datapipe Logs",
  FETCH_A_DATAPIPE_LOGS_SUCCESS: "[Datapipe] Fetch a Datapipe Logs Success",
  FETCH_A_DATAPIPE_LOGS_FAILED: "[Datapipe] Fetch a Datapipe Logs failed",
};

export const LoadMoreDatapipe = (
  companyId,
  userId,
  page,
  size,
  query,
  order,
  orderBy,
  status,
  configuuid,
  connectorId,
) => ({
  type: types.LOAD_MORE_DATAPIPE,
  payload: {
    companyId,
    userId,
    page,
    size,
    order,
    query,
    orderBy,
    status,
    configuuid,
    connectorId,
  },
});

export const LoadMoreDatapipeSuccess = /* istanbul ignore next */ (list) => ({
  type: types.LOAD_MORE_DATAPIPE_SUCCESS,
  payload: list,
});
export const LoadMoreDatapipeFailed = /* istanbul ignore next */ (error) => ({
  type: types.LOAD_MORE_DATAPIPE_FAILED,
  payload: error,
});
//
// ─── FETCH DATAPIPE ACTIONS ─────────────────────────────────────────────────────
//

export const FetchDatapipe = (
  companyId,
  userId,
  page,
  size,
  query,
  order,
  orderBy,
  status,
  configuuid,
  connectorId,
) => ({
  type: types.FETCH_DATAPIPE,
  payload: {
    companyId,
    userId,
    page,
    size,
    order,
    query,
    orderBy,
    status,
    configuuid,
    connectorId,
  },
});
export const FetchDatapipeSuccess = (list) => ({
  type: types.FETCH_DATAPIPE_SUCCESS,
  payload: list,
});
export const FetchDatapipeFailed = (error) => ({
  type: types.FETCH_DATAPIPE_FAILED,
  payload: error,
});

//
// ─── FETCH SINGLE DATAPIPE ACTIONS ────────────────────────────────────────────────────────────────────────
//
export const FetchADatapipe = (id) => ({
  type: types.FETCH_A_DATAPIPE,
  payload: id,
});
export const FetchADatapipeSuccess = (list) => ({
  type: types.FETCH_A_DATAPIPE_SUCCESS,
  payload: list,
});
export const FetchADatapipeFailed = (error) => ({
  type: types.FETCH_A_DATAPIPE_FAILED,
  payload: error,
});

//
// ─── CHANGE STATUS DATAPIPE ACTIONS ────────────────────────────────────────────────────────────────────────
//
export const ChangeStatusDatapipe = (id, status) => ({
  type: types.CHANGE_STATUS_DATAPIPE,
  payload: { id, status },
});
export const ChangeStatusDatapipeSuccess = (response) => ({
  type: types.CHANGE_STATUS_DATAPIPE_SUCCESS,
  payload: response,
});
export const ChangeStatusDatapipeFailed = (error) => ({
  type: types.CHANGE_STATUS_DATAPIPE_FAILED,
  payload: error,
});

//
// ─── CREATE DATAPIPE ACTIONS─────────────────────────────────────────────────────────────────────
//
export const CreateDatapipe = (datapipe) => ({
  type: types.CREATE_DATAPIPE,
  payload: datapipe,
});
export const CreateDatapipeSuccess = (response) => ({
  type: types.CREATE_DATAPIPE_SUCCESS,
  payload: response,
});
export const CreateDatapipeFailed = (error) => ({
  type: types.CREATE_DATAPIPE_FAILED,
  payload: error,
});

//
// ─── UPDATE DATAPIPE ACTIONS ────────────────────────────────────────────────────
//
export const UpdateDatapipe = (datapipe) => ({
  type: types.UPDATE_DATAPIPE,
  payload: datapipe,
});
export const UpdateDatapipeSuccess = (response) => ({
  type: types.UPDATE_DATAPIPE_SUCCESS,
  payload: response,
});
export const UpdateDatapipeFailed = (error) => ({
  type: types.UPDATE_DATAPIPE_FAILED,
  payload: error,
});
//
// ─── RERENDER DATAPIPE────────────────────────────────────────────────────
//
export const RerenderDatapipe = () => ({
  type: types.RERENDER_DATAPIPE,
});
//
// ─── ADD_COLLECTOR_TO_DATAPIPE────────────────────────────────────────────────────
//
export const AddCollectorTODatapipe = (datapipe) => ({
  type: types.ADD_COLLECTOR_TO_DATAPIPE,
  payload: datapipe,
});

//
// ─── CHANGE NAME DATAPIPE────────────────────────────────────────────────────
//
export const ChangeCurrentDatapipeName = (name) => ({
  type: types.CHANGE_CURRENT_DATAPIPE_NAME,
  payload: name && name.replace(/\s\s+/g, " ").trim().length > 0 ? name : "",
});

//
// ─── ADD PLAYER DATA TO DATAPIPE───────────────────────────────────────────────────
//
export const AddPlayerDataToDatapipe = (data) => ({
  type: types.ADD_PLAYERDATA_TO_DATAPIPE,
  payload: data,
});
//
// ─── ADD CONNECTOR DATA TO DATAPIPE───────────────────────────────────────────────────
//
export const AddConnectorToDatapipe = (data) => ({
  type: types.ADD_CONNECTOR_TO_DATAPIPE,
  payload: data,
});
//
// ─── REMOVE CONNECTOR FROM DATAPIPE───────────────────────────────────────────────────
//
export const RemoveConnectorFromDatapipe = (data) => ({
  type: types.REMOVE_CONNECTOR_FROM_DATAPIPE,
  payload: data,
});

//
// ─── REMOVE COLLECTOR FROM DATAPIPE───────────────────────────────────────────────────
//
export const RemoveCollectorFromDatapipe = (data) => ({
  type: types.REMOVE_COLLECTOR_FROM_DATAPIPE,
  payload: data,
});
//
// ─── RESET CURRENT DATAPIPE───────────────────────────────────────────────────
//
export const ResetCurrentDatapipe = () => ({
  type: types.RESET_CURRENT_DATAPIPE,
});

//
// ─── RESET CURRENT DATAPIPE───────────────────────────────────────────────────
//
export const VerifyPlayers = /* istanbul ignore next */ (players) => ({
  type: types.VERIFY_PLAYERS,
  payload: players,
});
//
// ─── STORE DATAPIPE SEARCH───────────────────────────────────────────────────
//
export const StoreDatapipeSearch = (store) => ({
  type: types.STORE_DATAPIPE_SEARCH,
  payload: store,
});
//
// ─── REMOVE DATAPIPE SEARCH───────────────────────────────────────────────────
//
export const RemoveDatapipeSearch = () => ({
  type: types.REMOVE_DATAPIPE_SEARCH,
});
export const SetDatapipeFilterActiveDisable = (filter) => ({
  type: types.SET_DATAPIPE_FILTER_ACTIVE_DISABLE,
  payload: filter,
});
export const RemoveDatapipeFilterActiveDisable = () => ({
  type: types.REMOVE_DATAPIPE_FILTER_ACTIVE_DISABLE,
});
// /////// ---- Fetch a Datapipe for Delete Container -----------
export const FetchADatapipeDel = (id) => ({
  type: types.FETCH_A_DATAPIPE_DEL,
  payload: id,
});
export const FetchADatapipeDelSuccess = (list) => ({
  type: types.FETCH_A_DATAPIPE_DEL_SUCCESS,
  payload: list,
});
export const FetchADatapipeDelFailed = (error) => ({
  type: types.FETCH_A_DATAPIPE_DEL_FAILED,
  payload: error,
});
// /////////Delete Datapipe//////////
export const DeleteDatapipe = (id) => ({
  type: types.DELETE_DATAPIPE,
  payload: id,
});
export const DeleteDatapipeSuccess = (response) => ({
  type: types.DELETE_DATAPIPE_SUCCESS,
  payload: response,
});
export const DeleteDatapipeFailed = (error) => ({
  type: types.DELETE_DATAPIPE_FAILED,
  payload: error,
});
export const RemoveDelDatapipe = () => ({
  type: types.REMOVE_DEL_DATAPIPE,
});
export const ClearDataPipeList = () => ({
  type: types.CLEAR_DATAPIPE_LIST,
});
export const ClearErrorResponse = () => ({
  type: types.CLEAR_ERROR_RESPONSE,
});
export const ClearDatapipeErrorResponse = () => ({
  type: types.CLEAR_ERROR_DATA_PIPE_RESPONSE,
});
export const ClearDatapipeSuccessResponse = () => ({
  type: types.CLEAR_SUCCESS_DATA_PIPE_RESPONSE,
});

export const HideDatapipe = (data) => ({
  type: types.HIDE_DATAPIPE,
  payload: data,
});

export const HideDatapipeSuccess = (data) => ({
  type: types.HIDE_DATAPIPE_SUCCESS,
  payload: data,
});

export const HideDatapipeFailed = (data) => ({
  type: types.HIDE_DATAPIPE_FAILED,
  payload: data,
});
export const IntialDatapipeValue = (data) => ({
  type: types.INITIAL_DATAPIPE_VALUE,
  payload: data,
});

export const FetchDatapipeLogs = (collector) => ({
  type: types.FETCH_A_DATAPIPE_LOGS,
  payload: collector,
});
export const FetchADatapipeLogsSuccess = (logs) => ({
  type: types.FETCH_A_DATAPIPE_LOGS_SUCCESS,
  payload: logs,
});
export const FetchDatapipeLogsFailed = (error) => ({
  type: types.FETCH_A_DATAPIPE_LOGS_SUCCESS,
  payload: error,
});
